"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMarkdownParser = void 0;
const markdown_it_1 = __importDefault(require("markdown-it"));
const defaultRender = (tokens, idx, options, env, self) => self.renderToken(tokens, idx, options);
/**
 * Markdown parser set to open links in a new tab *unless* it's a `tel:` link
 * @returns {markdownParser}
 */
const buildMarkdownParser = () => {
    const md = new markdown_it_1.default();
    const render = md.renderer.rules.link_open || defaultRender;
    md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const aIndex = tokens[idx].attrIndex('target');
        const href = tokens[idx].attrGet('href') || '';
        const isPhoneLink = href.indexOf('tel:') != -1;
        if (!isPhoneLink) {
            if (aIndex < 0) {
                tokens[idx].attrPush(['target', '_blank']);
            }
            else {
                tokens[idx].attrs[aIndex][1] = '_blank';
            }
        }
        return render(tokens, idx, options, env, self);
    };
    return md;
};
exports.buildMarkdownParser = buildMarkdownParser;
//# sourceMappingURL=buildMarkdownParser.js.map